import { intro, introMobile } from "../../asset";

export default function LoginIntro() {
  return (
    <div
      className="flex flex-col gap-4 items-center text-white pt-10 px-8 md:rounded-lg md:justify-center 
      bg-[radial-gradient(62.44%_67.6%_at_87.16%_88.49%,_#BBCFF9_0%,_#5182EF_100%)]"
    >
      <div className="flex flex-col gap-3">
        <h2 className="text-[26px] md:text-[32px] xl:text-[42px] font-semibold">
          Manage Students, Staff & Academics — All in One Place!
        </h2>
        <p className="text-base font-medium hidden md:block">
          From enrollment to reports — streamline every process with a single,
          intuitive platform built for modern institutions.
        </p>
      </div>
      <div className="w-full flex-1 flex flex-col justify-end items-end md:items-center">
        <img
          src={intro}
          alt="Manage Students, Staff & Academics — All in One Place!"
          className="hidden md:block"
        ></img>
        <img
          src={introMobile}
          alt="Manage Students, Staff & Academics — All in One Place!"
          className="md:hidden mt-auto self-end"
        />
      </div>
    </div>
  );
}
